import Box from '@amzn/awsui-components-react/polaris/box';
import Link, { LinkProps } from '@amzn/awsui-components-react/polaris/link';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';
import React, { FC } from 'react';

export interface LinkAsyncProps extends LinkProps {
    loading?: boolean;
}

const LinkAsync: FC<LinkAsyncProps> = ({ children, loading, ...linkProps }) => (
    <Link {...linkProps}>
        {children}
        {loading && (
            <Box margin={{ left: 'xxs' }} display="inline">
                <Spinner />
            </Box>
        )}
    </Link>
);

export default LinkAsync;
